module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_8019.83b02e4e.png";